/**
 * @license
 * Copyright 2023 Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
const classes = {
    FLOATING_LABEL: 'forge-floating-label',
    FLOAT_ABOVE: 'forge-floating-label--float-above',
    FLOAT_ABOVE_END_KEYFRAME: 'forge-floating-label--float-above-end-keyframe',
    UNFLOAT_ABOVE_START_KEYFRAME: 'forge-floating-label--unfloat-above-start-keyframe'
};
export const FLOATING_LABEL_CONSTANTS = {
    classes
};
